import { reactive } from 'vue'

const MAX_TOASTS = 3
let uid = 0

const toasts = reactive([])

const confirmState = reactive({
  open: false,
  title: '',
  message: '',
  confirmText: 'Confirmar',
  cancelText: 'Cancelar',
  danger: false,
  resolve: null,
})

function dismissToast(id) {
  const i = toasts.findIndex(t => t.id === id)
  if (i !== -1) toasts.splice(i, 1)
}

function pushToast(type, message, opts = {}) {
  if (toasts.length >= MAX_TOASTS) toasts.shift()
  const id = ++uid
  toasts.push({ id, type, message, action: opts.action || '', onAction: opts.onAction || null })
  // Con botón de acción («Deshacer») dura más para alcanzar a usarlo
  setTimeout(() => dismissToast(id), opts.duration || (opts.action ? 6000 : 4200))
}

export const notify = {
  success: (msg, opts) => pushToast('exito', msg, opts),
  error:   (msg, opts) => pushToast('error', msg, opts),
  warn:    (msg, opts) => pushToast('aviso', msg, opts),
  info:    (msg, opts) => pushToast('info', msg, opts),
}

// Reemplazo directo de window.confirm: `if (!(await confirmDialog({...}))) return`
export function confirmDialog({ title, message, confirmText = 'Confirmar', cancelText = 'Cancelar', danger = false }) {
  return new Promise(resolve => {
    Object.assign(confirmState, { open: true, title, message, confirmText, cancelText, danger, resolve })
  })
}

function resolveConfirm(result) {
  confirmState.open = false
  if (confirmState.resolve) {
    confirmState.resolve(result)
    confirmState.resolve = null
  }
}

// Estado compartido que consume AppNotifications.vue
export function useNotifyState() {
  return { toasts, dismissToast, confirmState, resolveConfirm }
}
